export { default } from './bank-statement-modal';
